import { useState } from 'react';
import { confirm, useNotificationsStore } from '@thermon-platforms/thermon-ui-core';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import api from 'util/api';
import useDevicesStore from 'store/devices';


function UpgradeController({device}) {
  const [loading, setLoading] = useState(false);
  const [, devicesStoreActions] = useDevicesStore();
  const [, notificationsStoreActions] = useNotificationsStore();

  // NOTE - there is probably a cleaner way to manage translating
  // between device models, but for now let's just be deliberate.
  const isToTCM18 = [3, 4, 5].includes(device?.model?.deviceModel);
  const newDeviceId = isToTCM18 ? 13 : 4; // TCM18
  const newDeviceType = isToTCM18 ? 'TCM18' : 'TC1818';
  const oldDeviceType = isToTCM18 ? 'TC1818' : 'TCM18';

  function doUpgrade() {
    setLoading(true);

    api(`/devices/${device.model.id}/swap`, {
      method: 'PATCH',
      body: JSON.stringify({
        parentId: device.path[device.path.length - 1].id,
        newName: device.model.name.replace(oldDeviceType, newDeviceType), // Use the same name but replace old device name with new device name if relevant
        newDeviceModel: newDeviceId
      })
    })
      .then(() => {
        // Re-query our devices so the UI gets updated
        devicesStoreActions.query();
      })
      .catch(() => {
        notificationsStoreActions.notify(
          t`Upgrade failed`,
          'alert'
        );
      })
      .finally(() => {
        setLoading(false);
      });
  }

  function handleClick() {
    confirm({
      header: t`Are you sure you want to upgrade ${device.model.name} to a ${newDeviceType}?`
    })
      .then(doUpgrade)
      .catch(() => {/* no-op */})
  }

  return (
    <div className="secondary-management-section">
      <h3><Trans>Advanced Settings</Trans></h3>
      <button
        className={loading ? 'processing' : ''}
        onClick={handleClick}
        disabled={loading}
      >
        <Trans>Swap to</Trans> {newDeviceType}
      </button>
    </div>
  );
}

export default UpgradeController;
